import { useController, Control } from 'react-hook-form';
import BaseCombobox, { OptionCombobox } from '.';

interface RHFComboboxProps {
  name: string;
  control: Control<any>;
  label: string;
  options: OptionCombobox[];
  isMultiple?: boolean;
  errorMessage?: string;
  valueMultiple?: any;
  onChangeMultiple?: any;
}

export default function ReactHookFormCombobox({
  name,
  control,
  label,
  options,
  isMultiple = false,
  errorMessage,
}: RHFComboboxProps) {
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({ name, control });

  return (
    <BaseCombobox
      label={label}
      options={options}
      isMultiple={isMultiple}
      value={value}
      onChange={onChange}
      errorMessage={error?.message || errorMessage}
    />
  );
}
